/**
 * Rift Counters
 *
 * Minimal number count-up helper to replace CountUp.
 *
 * Markup convention:
 * - Element has data-count-end="3000" and optional data-count-suffix="+".
 */
(() => {
  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  const parseNumberFromText = (value) => {
    if (!value) return 0;

    const cleaned = String(value).replace(/[^0-9.-]/g, '');
    const numberValue = Number(cleaned);

    return Number.isFinite(numberValue) ? numberValue : 0;
  };

  const formatInteger = (value) =>
    Math.round(value).toLocaleString(undefined, { maximumFractionDigits: 0 });

  const animate = (element, options) => {
    if (!element || element.dataset.riftCountAnimated === 'true') return;

    const endVal = Number(options?.endVal);
    if (!Number.isFinite(endVal)) return;

    const suffix = options?.suffix ?? element.dataset.countSuffix ?? '';
    const duration = Math.max(0, Number(options?.duration ?? 2500));

    const startVal = Number.isFinite(Number(options?.startVal))
      ? Number(options?.startVal)
      : parseNumberFromText(element.textContent);

    element.dataset.riftCountAnimated = 'true';

    if (prefersReducedMotion() || duration === 0) {
      element.textContent = `${formatInteger(endVal)}${suffix}`;
      return;
    }

    let startTime = 0;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;

      const elapsed = timestamp - startTime;
      const t = Math.min(1, elapsed / duration);
      const progress = easeOutCubic(t);
      const currentValue = startVal + (endVal - startVal) * progress;

      element.textContent = `${formatInteger(currentValue)}${suffix}`;

      if (t < 1) window.requestAnimationFrame(step);
    };

    window.requestAnimationFrame(step);
  };

  window.RiftCounters = {
    animate,
  };
})();
